export default "__VITE_ASSET__js38WjIt__"